module.exports = __webpack_public_path__ + "static/assets/f93e4639b84a1cf674adbddeea141a9c.jpg";